// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scaffold-pricing-container {
    /* width: 300px; */
    margin: 0 auto;
    font-family: Arial, sans-serif;
    color: #333;
    text-align: center;
}

h2 {
    font-size: 24px;
    color: #333;
    margin-bottom: 15px;
}

/* Dropdown Styling */
.dropdown-container {
    display: inline-block;
    background-color: #f0f8ff;
    border: 1px solid #007bff;
    border-radius: 8px;
    padding: 5px;
    margin-bottom: 20px;
    margin-top: 20px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    /* width: 100%; */
}

.dropdown {
    width: 100%;
    padding: 10px;
    font-size: 16px;
    color: #333;
    border: none;
    background: transparent;
    outline: none;
    appearance: none; /* Remove default arrow for custom style */
    cursor: pointer;
}

/* Custom dropdown arrow */
.dropdown-container::after {
    content: '▼';
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    color: #007bff;
}

/* Price Details Box */
.price-details {
    display: flex;
    background-color: #f0f8ff;
    border: 1px solid #007bff;
    border-radius: 8px;
    padding: 15px;
    margin-top: 20px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.price-details h3 {
    font-size: 20px;
    color: #007bff;
    margin-bottom: 10px;
}

.price-row {
    display: grid;
    justify-content: space-between;
    padding: 4px 0;
    font-size: 14px;
    margin-left: 20px;
}

.price-row span {
    font-weight: 500;
}

.placeholder {
    color: #666;
    font-size: 16px;
    margin-top: 20px;
    text-align: center;
}

.save-button{
    background-color: #007bff;
    color: #f0f8ff;
}

.admin-input{
    height: 100%;
    width: 50%;
    border-radius: 5px;
    border-width: 2px;
    --tw-border-opacity: 1;
    border-color: rgb(204 204 204 / var(--tw-border-opacity));
    padding-left: 45px;
}`, "",{"version":3,"sources":["webpack://./src/components/createProject/ScaffoldPricing.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,cAAc;IACd,8BAA8B;IAC9B,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB;IACI,qBAAqB;IACrB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,wCAAwC;IACxC,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,gBAAgB,EAAE,0CAA0C;IAC5D,eAAe;AACnB;;AAEA,0BAA0B;AAC1B;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,cAAc;AAClB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,yDAAyD;IACzD,kBAAkB;AACtB","sourcesContent":[".scaffold-pricing-container {\n    /* width: 300px; */\n    margin: 0 auto;\n    font-family: Arial, sans-serif;\n    color: #333;\n    text-align: center;\n}\n\nh2 {\n    font-size: 24px;\n    color: #333;\n    margin-bottom: 15px;\n}\n\n/* Dropdown Styling */\n.dropdown-container {\n    display: inline-block;\n    background-color: #f0f8ff;\n    border: 1px solid #007bff;\n    border-radius: 8px;\n    padding: 5px;\n    margin-bottom: 20px;\n    margin-top: 20px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    /* width: 100%; */\n}\n\n.dropdown {\n    width: 100%;\n    padding: 10px;\n    font-size: 16px;\n    color: #333;\n    border: none;\n    background: transparent;\n    outline: none;\n    appearance: none; /* Remove default arrow for custom style */\n    cursor: pointer;\n}\n\n/* Custom dropdown arrow */\n.dropdown-container::after {\n    content: '▼';\n    position: absolute;\n    right: 15px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: #007bff;\n}\n\n/* Price Details Box */\n.price-details {\n    display: flex;\n    background-color: #f0f8ff;\n    border: 1px solid #007bff;\n    border-radius: 8px;\n    padding: 15px;\n    margin-top: 20px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.price-details h3 {\n    font-size: 20px;\n    color: #007bff;\n    margin-bottom: 10px;\n}\n\n.price-row {\n    display: grid;\n    justify-content: space-between;\n    padding: 4px 0;\n    font-size: 14px;\n    margin-left: 20px;\n}\n\n.price-row span {\n    font-weight: 500;\n}\n\n.placeholder {\n    color: #666;\n    font-size: 16px;\n    margin-top: 20px;\n    text-align: center;\n}\n\n.save-button{\n    background-color: #007bff;\n    color: #f0f8ff;\n}\n\n.admin-input{\n    height: 100%;\n    width: 50%;\n    border-radius: 5px;\n    border-width: 2px;\n    --tw-border-opacity: 1;\n    border-color: rgb(204 204 204 / var(--tw-border-opacity));\n    padding-left: 45px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
